import { debounce } from 'lodash'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { TextInput } from 'src/components/TextInput'
import { adjustmentActions, selectFilterInternalUsers } from '../adjustmentSlice'

const SEARCH_DEBOUNCE_MS = 200

type AdjustmentParticipantUserSearchFieldProps = {
    onClearRightSelection?: () => void
}

const AdjustmentParticipantUserSearchField = ({
    onClearRightSelection,
}: AdjustmentParticipantUserSearchFieldProps) => {
    const dispatch = useAppDispatch()
    const filterInternalUsers = useAppSelector(selectFilterInternalUsers)
    const [searchText, setSearchText] = useState(filterInternalUsers.text ?? '')
    const filterRef = useRef(filterInternalUsers)
    const onClearRightSelectionRef = useRef(onClearRightSelection)

    filterRef.current = filterInternalUsers
    onClearRightSelectionRef.current = onClearRightSelection

    const scheduleSearch = useMemo(
        () =>
            debounce((text: string) => {
                dispatch(
                    adjustmentActions.setFilterInternalUser({
                        ...filterRef.current,
                        text,
                    }),
                )
                onClearRightSelectionRef.current?.()
            }, SEARCH_DEBOUNCE_MS),
        [dispatch],
    )

    useEffect(() => {
        return () => {
            scheduleSearch.cancel()
        }
    }, [scheduleSearch])

    useEffect(() => {
        setSearchText(filterInternalUsers.text ?? '')
    }, [filterInternalUsers.text])

    return (
        <TextInput
            value={searchText}
            autoComplete="off"
            onChange={(event: any) => {
                const value = event.target.value
                setSearchText(value)
                scheduleSearch(value)
            }}
            placeholder="ユーザを探す"
        />
    )
}

export default AdjustmentParticipantUserSearchField
